import {
  Box,
  FormControl,
  FormLabel,
  Icon,
  Switch,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';
import { MdInfoOutline } from 'react-icons/md';

const CommonSwitchInput = ({
  labelText,
  name,
  register,
  errors,
  isValidate = true,
  defaultChecked = false,
  textColor,
  brandStars,
  isDisabled = false,
  control,
  infoText = '',
}) => {
  return (
    <Box mt={4}>
      <FormControl display="flex" alignItems="center">
        <Controller
          name={name}
          control={control}
          defaultValue={defaultChecked}
          render={({ field: { onChange, value } }) => (
            <Switch
              id={name}
              name={name}
              isChecked={value}
              onChange={onChange}
              {...register}
              isDisabled={isDisabled}
              size="md"
              mr={3}
              sx={{
                'span.chakra-switch__track[data-checked]': {
                  backgroundColor: '#203946',
                },
              }}
            />
          )}
        />
        <FormLabel
          htmlFor={name}
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          mb="0"
        >
          {labelText}
          {isValidate && (
            <Text as="span" color={brandStars}>
              {' '}
              *
            </Text>
          )}
        </FormLabel>
        {infoText && (
          <Tooltip
            label={infoText}
            placement="top"
            hasArrow
            bg="gray.800"
            color="white"
            fontSize="xs"
            borderRadius="md"
            py={2}
            px={3}
            maxWidth="280px"
            boxShadow="xl"
            arrowShadowColor="gray.800"
          >
            <Box
              as="span"
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              ml={1}
              cursor="help"
              color="gray.500"
              _hover={{ color: 'gray.700' }}
            >
              <Icon as={MdInfoOutline} boxSize={4} />
            </Box>
          </Tooltip>
        )}
      </FormControl>
      {errors && (
        <Text color="red" fontSize="sm">
          {errors.message}
        </Text>
      )}
    </Box>
  );
};

CommonSwitchInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  register: PropTypes.object,
  errors: PropTypes.object,
  isValidate: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  textColor: PropTypes.string,
  brandStars: PropTypes.string,
  isDisabled: PropTypes.bool,
  control: PropTypes.object,
  infoText: PropTypes.string,
};

export default CommonSwitchInput;
